module.exports = __webpack_public_path__ + "img/badge-list-thumb-018.d1cca592.png";